// extracted by mini-css-extract-plugin
export default {"root":"MediaPair-module--root--d2a9e","content":"MediaPair-module--content--56963"};